export default __webpack_public_path__ + "static/media/modelyy.72cec735.jpg";